import React from 'react';
import './bottom-info.css';

const BottomInfo = () => {
  const generalEmail = 'hello@zonetail.com';
  const mediaEmail = 'media@zonetail.com';
  const investorEmail = 'ir@zonetail.com';

  return (
    <div className="bottom-info">
      {/* about */}
      <div className="info-section">
        <p className="info-title">ABOUT ZONETAIL</p>
        <p className="info-body">
          Zonetail (TSXV:ZONE) is a mobile platform for hotels and condominiums
          that provides guests and residents access and interaction with
          building amenities and services as well as neighboring restaurants,
          stores, services, and attractions.
        </p>
      </div>
      {/* contact us */}
      <div className="info-section">
        <p className="info-title">CONTACT US</p>
        <div className="info-body">
          General:{' '}
          <a className="info-body-link" href={`mailto:${generalEmail}`}>
            {generalEmail}
          </a>
          <br />
          Media:{' '}
          <a className="info-body-link" href={`mailto:${mediaEmail}`}>
            {mediaEmail}
          </a>
          <br />
          Investors:{' '}
          <a className="info-body-link" href={`mailto:${investorEmail}`}>
            {investorEmail}
          </a>
        </div>
      </div>
      {/* legal */}
      <div className="info-section">
        <p className="info-title">LEGAL</p>
        <div className="info-body">
          <a
            href="https://www.zonetail.com/terms-of-service/"
            className="info-body-link"
          >
            &gt; TERMS OF SERVICE
          </a>
          <br />
          <br />
          <a
            href="https://www.zonetail.com/privacy-policy/"
            className="info-body-link"
          >
            &gt; PRIVACY POLICY
          </a>
          <br />
          <br />
          <a
            href="https://www.zonetail.com/forward-looking-statements-and-legal-disclaimers/"
            className="info-body-link"
          >
            &gt; FORWARD LOOKING STATEMENTS
          </a>
        </div>
      </div>
    </div>
  );
};

export default BottomInfo;
